<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ asstype }}
        <i class="caret"></i>
      </span>
      <select
        class="filter-item__select"
        v-model="asstype"
        @change="searchFeeStatistics"
      >
        <option :value="'全部'">全部</option>
        <option :value="'部门'">部门</option>
        <option :value="'员工'">员工</option>
        <option :value="'项目'">项目</option>
      </select>
    </div>

    <div class="canvas-box" v-show="result.monthitems">
      <canvas id="myChart" class="myChart"></canvas>
    </div>
    <div class="list-empty" v-if="!result.monthitems">暂无数据</div>
    <!-- <div class="canvas-box" v-if="asstype == '全部'">
      <canvas id="pieChart" class="pieChart"></canvas>
    </div> -->

    <div class="list-box" v-if="result.details">
      <div class="list-box-fixed">
        <p class="list-box-col__title">月份</p>
        <p class="list-box-col__content" v-for="month in 12" :key="month">
          {{ getMonth(month) }}月
        </p>
        <p class="list-box-col__content">本年累计</p>
      </div>
      <div class="list-box-flex">
        <div
          class="list-box-flex__item"
          v-for="(item, index) in result.filtedDetails"
          :key="item.text"
          @click="initChart(deal2(item))"
        >
          <p class="list-box-col__title">{{ item.caname || "未命名" }}</p>
          <p class="list-box-col__content" v-for="month in 12" :key="month">
            {{
              numberFormat(
                result.filtedDetails[index]["amount" + month],
                "#,##0.##"
              ) || 0
            }}
          </p>
          <p class="list-box-col__content">
            {{
              numberFormat(result.filtedDetails[index]["amount"], "#,##0.##") ||
              0
            }}
          </p>
        </div>
        <div
          class="list-box-flex__item"
          @click="initChart(deal(result.monthitems))"
        >
          <p class="list-box-col__title">{{ "月合计" }}</p>
          <p class="list-box-col__content" v-for="month in 12" :key="month">
            {{
              numberFormat(result.monthitems[month - 1]?.amount, "#,##0.##") ||
              0
            }}
          </p>
          <p class="list-box-col__content">
            {{
              numberFormat(
                result.monthitems.reduce((sum, item) => sum + item.amount, 0),
                "#,##0.##"
              ) || 0
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      year,
      asstype: "全部",
      asstypeObj: {
        全部: "全部",
        部门: "Dept",
        员工: "Empl",
        项目: "Project",
      },
      opened: -1,
      chart: null,
    };
  },
  mounted() {
    this.searchFeeStatistics();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchFeeStatistics() {
      let me = this;

      let asstype = me.asstypeObj[me.asstype];

      let params = {
        year: me.year,
        asstype,
      };
      if (asstype != "全部") {
        params.assid = -1;
      }

      me.$ajax({
        url: "/api/finance/feestatistics/getFeeStatistics",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          if (me.result && me.result.monthitems) {
            me.initChart(me.deal(me.result.monthitems));
          }
          // if(asstype == '全部') me.initPieChart()
          if (me.result && me.result.details) {
            me.result.filtedDetails = me.result.details.filter(
              (item) => !item.pcaid
            );
          }
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });
      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },

    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          text: textArr[i],
          type: "金额",
          index: i,
          value: data[i]?.amount || 0,
        });
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 12, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchFeeStatistics();
        },
      });
    },
    getMonth(month) {
      return month < 10 ? "0" + month : month;
    },
  },
};
</script>

<style scoped>
.list-empty {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
  position: relative;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  width: 100%;
  line-height: 40px;
  text-align: center;
  display: flex;
}
.list-box-fixed {
  width: 68px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-box-flex {
  flex: 1;
  overflow-x: scroll;
  display: flex;
}
.list-box-flex__item {
  flex-grow: 1;
  flex-shrink: 0;
  margin: 0 10px;
}
.list-box-col__title {
  font-weight: bold;
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}
.list-box-flex__item:active {
  background-color: #e0e0e0;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap {
    width: 100%;
  }
  .list-box {
    line-height: 25px;
  }
}
</style>